import { authHeader } from '../helpers/authHeader';
let abortSignals = {}


export function requestOption(data, signalName, isLoading) {
    let fData = new FormData();
    for ( var key in data ) {
        if (Array.isArray(data[key])) {
            for ( var key2 in data[key] ) {
                fData.append(key+'[]', data[key][key2]);
            }
        } else {
            fData.append(key, data[key]);
        }
    }

    if (typeof  abortSignals[signalName] == 'undefined') {
        abortSignals[signalName] = null
    }
    let abortController = abortSignals[signalName]

    
    if (abortController && isLoading) {
        abortController.abort()
    }
    abortSignals[signalName] = new AbortController()
    
    return  {
            method: 'POST',
            body: fData,
            signal: abortSignals[signalName].signal,
            headers: authHeader()
    };
}